import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { RiCalendarLine, RiHeartPulseLine } from "react-icons/ri";
import { Button, Card } from "@/components/ui";
import { useSelfScheduleContext } from "@/contexts/self-schedule-provider";
import { usePatientVerification } from "@/hooks/self-schedule/use-patient-verification";
import { formatDateWithDay, formatList } from "@/lib/format-data";
import { isVirtualServiceCart } from "@/lib/self-schedule-virtual-services";
import { selfScheduleQueryOptions } from "@/api/check-in/self-schedule/self-schedule-query";
import { tenantQueryOptions } from "@/query/tenant";
import { LocationType, SelfScheduleStep } from "@/stores/self-schedule-store";
export const CarePlanSuggestionCard = () => {
  const $ = _c(60);
  const {
    patient
  } = usePatientVerification();
  const {
    addSelectedService,
    clearSelectedServices,
    setSelectedLocationId,
    setLocationType,
    setConfirmedServiceSelections,
    setDismissedCarePlanSuggestion,
    setAppliedCarePlanStepId,
    setCurrentStep
  } = useSelfScheduleContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...tenantQueryOptions.public(),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: tenantName
  } = useQuery(t0);
  const suggestion = patient?.nextCarePlanAppointment;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...selfScheduleQueryOptions.frontPage(),
      select: _temp2
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: frontPageData
  } = useQuery(t1);
  if (!suggestion || !frontPageData?.services) {
    return null;
  }
  const t2 = frontPageData.services;
  let T0;
  let handleBook;
  let t10;
  let t11;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== addSelectedService || $[3] !== clearSelectedServices || $[4] !== frontPageData.locations || $[5] !== frontPageData.services || $[6] !== setAppliedCarePlanStepId || $[7] !== setConfirmedServiceSelections || $[8] !== setCurrentStep || $[9] !== setDismissedCarePlanSuggestion || $[10] !== setLocationType || $[11] !== setSelectedLocationId || $[12] !== suggestion || $[13] !== tenantName) {
    t11 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t12;
      if ($[25] !== suggestion) {
        t12 = s => suggestion.serviceIds.includes(s.id);
        $[25] = suggestion;
        $[26] = t12;
      } else {
        t12 = $[26];
      }
      const suggestedServices = t2.filter(t12);
      if (suggestedServices.length === 0) {
        t11 = null;
        break bb0;
      }
      const suggestedLocation = frontPageData.locations?.find(l => l.id === suggestion.locationId);
      handleBook = () => {
        setDismissedCarePlanSuggestion(true);
        setAppliedCarePlanStepId(suggestion.stepId);
        clearSelectedServices();
        for (const service of suggestedServices) {
          addSelectedService(service.id, service.name);
        }
        setConfirmedServiceSelections(true);
        if (isVirtualServiceCart(suggestedServices)) {
          setLocationType(LocationType.VIRTUAL);
          setSelectedLocationId(null);
        } else {
          if (suggestedLocation) {
            setLocationType(suggestedLocation.isVirtual ? LocationType.VIRTUAL : LocationType.IN_PERSON);
            setSelectedLocationId(suggestedLocation.id, suggestedLocation.name);
          }
        }
        setCurrentStep(SelfScheduleStep.TIME, "forward");
      };
      T0 = Card;
      t10 = "motion-ease-spring-bouncy motion-opacity-in-85 motion-scale-in-105 border p-6 shadow-md";
      t8 = "flex flex-col gap-4";
      if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = <div className="flex items-center gap-2"><RiHeartPulseLine className="size-5 shrink-0" /><h3 className="text-h3 text-foreground">Next step in your care plan</h3></div>;
        $[27] = t9;
      } else {
        t9 = $[27];
      }
      t3 = "text-foreground-secondary";
      t4 = tenantName;
      t5 = " recommends a";
      t6 = " ";
      t7 = formatList(suggestedServices.map(_temp3));
    }
    $[2] = addSelectedService;
    $[3] = clearSelectedServices;
    $[4] = frontPageData.locations;
    $[5] = frontPageData.services;
    $[6] = setAppliedCarePlanStepId;
    $[7] = setConfirmedServiceSelections;
    $[8] = setCurrentStep;
    $[9] = setDismissedCarePlanSuggestion;
    $[10] = setLocationType;
    $[11] = setSelectedLocationId;
    $[12] = suggestion;
    $[13] = tenantName;
    $[14] = T0;
    $[15] = handleBook;
    $[16] = t10;
    $[17] = t11;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    T0 = $[14];
    handleBook = $[15];
    t10 = $[16];
    t11 = $[17];
    t3 = $[18];
    t4 = $[19];
    t5 = $[20];
    t6 = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  if (t11 !== Symbol.for("react.early_return_sentinel")) {
    return t11;
  }
  let t12;
  if ($[28] !== suggestion.scheduledDate) {
    t12 = formatDateWithDay(suggestion.scheduledDate);
    $[28] = suggestion.scheduledDate;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12) {
    t13 = <strong>{t12}</strong>;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t13 || $[33] !== t3 || $[34] !== t4 || $[35] !== t5 || $[36] !== t6 || $[37] !== t7) {
    t14 = <p className={t3}>{t4}{t5}{t6}{t7} appointment around{" "}{t13}.</p>;
    $[32] = t13;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== setDismissedCarePlanSuggestion) {
    t15 = () => setDismissedCarePlanSuggestion(true);
    $[39] = setDismissedCarePlanSuggestion;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <span>Not now</span>;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t15) {
    t17 = <Button variant="secondary" onClick={t15}>{t16}</Button>;
    $[42] = t15;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <RiCalendarLine />;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <span>Book this appointment</span>;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== handleBook) {
    t20 = <Button onClick={handleBook} icon={t18} variant="primary">{t19}</Button>;
    $[46] = handleBook;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== t17 || $[49] !== t20) {
    t21 = <div className="flex justify-end gap-2">{t17}{t20}</div>;
    $[48] = t17;
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== t14 || $[52] !== t21 || $[53] !== t8 || $[54] !== t9) {
    t22 = <div className={t8}>{t9}{t14}{t21}</div>;
    $[51] = t14;
    $[52] = t21;
    $[53] = t8;
    $[54] = t9;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== T0 || $[57] !== t10 || $[58] !== t22) {
    t23 = <T0 className={t10}>{t22}</T0>;
    $[56] = T0;
    $[57] = t10;
    $[58] = t22;
    $[59] = t23;
  } else {
    t23 = $[59];
  }
  return t23;
};
function _temp(data) {
  return data?.name;
}
function _temp2(data_0) {
  return {
    services: data_0?.services,
    locations: data_0?.locations
  };
}
function _temp3(s_0) {
  return s_0.name;
}